import { fork, all, takeLatest } from 'redux-saga/effects'
// sagas
// client sagas
import * as authSagas from './AuthSagas'
import * as destinationSagas from './DestinationSagas'
import * as attractionSagas from './AttractionSagas'
import * as presetSagas from './PresetSagas'
import { uploadFiles } from './FilesSagas'
import * as popularAttractionSagas from './PopularAttractionSagas'
import * as couponSagas from './CouponSagas'
import * as couponProviderSagas from './CouponProviderSagas'
import * as couponPresetSagas from './CouponPresetSagas'
import * as productSagas from './ProductSagas'
import * as eventsSagas from './EventsSagas'
import * as insuranceSagas from './InsuranceSagas'
import * as bannerSagas from './BannerSagas'
import * as markupSagas from './MarkupSagas'
import * as exchangeRateSagas from './ExchangeRateSagas'
import * as userSagas from './UserSagas'
import * as orderSagas from './OrderSagas'
import * as transferHistorySagas from './TransferHistorySagas'
import * as reviewSagas from './ReviewSagas'
import * as dbSagas from './DbSagas'
import * as categorySagas from './CategorySagas'
import * as sizeSagas from './SizeSagas'
import * as colourSagas from './ColourSagas'
import * as brandSagas from './BrandSagas'
import * as warehouseSagas from './WarehouseSagas'
import * as inventorySagas from './InventorySagas'
import * as supplierSagas from './SupplierSagas'
import * as LocationSagas from './LocationSagas'
import * as ecommerceProductSagas from './EcommerceProductSagas'
import * as ecommerceOrderSagas from './EcommerceOrderSagas'
import * as sectionSagas from './SectionSagas'
import * as attractionPromoSagas from './AttractionPromoSagas'
import * as failedTransactionSagas from './FailedTransactionSagas'
import * as schedulerSagas from './SchedulerSagas'
import * as cronReportSagas from './CronReportSagas'
import * as promoSectionSagas from './PromoSectionSagas'
import * as esimsSagas from './EsimSagas'
// api
import API from '../Services/Api'
import { getToken } from '../Services/GetToken'
// Redux
import { AuthTypes } from '../Redux/AuthRedux'
import { DestinationTypes } from '../Redux/DestinationRedux'
import { PresetTypes } from '../Redux/PresetRedux'
import { FilesTypes } from '../Redux/FilesRedux'
import { AttractionTypes } from '../Redux/AttractionRedux'
import { PopularAttractionTypes } from '../Redux/PopularAttractionRedux'
import { CouponTypes } from '../Redux/CouponRedux'
import { CouponProviderTypes } from '../Redux/CouponProviderRedux'
import { CouponPresetTypes } from '../Redux/CouponPresetRedux'
import { ProductTypes } from '../Redux/ProductRedux'
import { EventsTypes } from '../Redux/EventsRedux'
import { InsuranceTypes } from '../Redux/InsuranceRedux'
import { BannerTypes } from '../Redux/BannerRedux'
import { MarkupTypes } from '../Redux/MarkupRedux'
import { ExchangeRateTypes } from '../Redux/ExchangeRateRedux'
import { UserTypes } from '../Redux/UserRedux'
import { OrderTypes } from '../Redux/OrderRedux'
import { TransferHistoryTypes } from '../Redux/TransferHistoryRedux'
import { ReviewTypes } from '../Redux/ReviewRedux'
import { DbTypes } from '../Redux/DbRedux'
import { CategoryTypes } from '../Redux/CategoryRedux'
import { SizeTypes } from '../Redux/SizeRedux'
import { ColourTypes } from '../Redux/ColourRedux'
import { BrandTypes } from '../Redux/BrandRedux'
import { WarehouseTypes } from '../Redux/WarehouseRedux'
import { SupplierTypes } from '../Redux/SupplierRedux'
import { LocationTypes } from '../Redux/LocationRedux'
import { InventoryTypes } from '../Redux/InventoryRedux'
import { EcommerceProductTypes } from '../Redux/EcommerceProductRedux'
import { EcommerceOrderTypes } from '../Redux/EcommerceOrderRedux'
import { SectionTypes } from '../Redux/SectionRedux'
import { AttractionPromoTypes } from '../Redux/AttractionPromoRedux'
import { FailedTransactionTypes } from '../Redux/FailedTransactionRedux'
import { SchedulerTypes } from '../Redux/SchedulerRedux'
import { CronReportTypes } from '../Redux/CronReportRedux'
import { PromoSectionTypes } from '../Redux/PromoSectionRedux'
import { EsimsTypes } from '../Redux/EsimRedux'
/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
const api = API.create()
const token = getToken

// register all sagas here
export default function * root () {
  yield all([
    fork(authSagas.login, api),
    fork(authSagas.checkLogin, api, token),
    takeLatest(AuthTypes.AUTH_LOGOUT, authSagas.logout),

    // PRESET NO TOKEN
    fork(presetSagas.getCurrencies, api),
    fork(presetSagas.getLanguages, api),
    fork(presetSagas.getCountries, api),
    fork(presetSagas.getPresetOrder, api),

    takeLatest(PresetTypes.PRESET_ORDER_REQUEST, presetSagas.getPresetOrder, api),
    takeLatest(PresetTypes.PRESET_ORDER_UPDATE_REQUEST, presetSagas.updatePresetOrder, api),
    takeLatest(PresetTypes.PRESET_ORDER_UPDATE_SUCCESS, presetSagas.getPresetOrder, api),

    // PRESET-BRANCH
    takeLatest(PresetTypes.GET_BRANCH_REQUEST, presetSagas.getBranch, api),
    takeLatest(PresetTypes.UPDATE_BRANCH_REQUEST, presetSagas.updateBranch, api),
    takeLatest(PresetTypes.UPDATE_BRANCH_SUCCESS, presetSagas.getBranch, api),

    // PRESET-SHIPPING
    takeLatest(PresetTypes.GET_SHIPPING, presetSagas.getShipping, api),
    takeLatest(PresetTypes.UPDATE_SHIPPING, presetSagas.updateShipping, api),
    takeLatest(PresetTypes.UPDATE_SHIPPING_SUCCESS, presetSagas.getShipping, api),

    // DESTINATION
    takeLatest(DestinationTypes.DESTINATION_REQUEST, destinationSagas.getDestination, api),
    takeLatest(DestinationTypes.DESTINATION_CREATE_REQUEST, destinationSagas.createDestination, api),
    takeLatest(DestinationTypes.DESTINATION_DELETE_REQUEST, destinationSagas.deleteDestination, api),
    takeLatest(DestinationTypes.DESTINATION_UPDATE_REQUEST, destinationSagas.updateDestination, api),
    takeLatest(DestinationTypes.CONTINENT_REQUEST, destinationSagas.getContinent, api),
    takeLatest(DestinationTypes.DESTINATION_CREATE_SUCCESS, destinationSagas.getDestination, api),
    takeLatest(DestinationTypes.DESTINATION_UPDATE_SUCCESS, destinationSagas.getDestination, api),
    takeLatest(DestinationTypes.DESTINATION_DELETE_SUCCESS, destinationSagas.getDestination, api),

    takeLatest(DestinationTypes.ADD_ATTRACTION_TO_DESTINATION_REQUEST, destinationSagas.addAttractionToDestination, api),
    takeLatest(DestinationTypes.ADD_ATTRACTION_TO_DESTINATION_SUCCESS, attractionSagas.getAttractionByDestination, api),
    takeLatest(DestinationTypes.DELETE_ATTRACTION_FROM_DESTINATION_REQUEST, destinationSagas.deleteAttractionFromDestination, api),
    takeLatest(DestinationTypes.DELETE_ATTRACTION_FROM_DESTINATION_SUCCESS, attractionSagas.getAttractionByDestination, api),

    takeLatest(DestinationTypes.ADD_PLACE_TO_DESTINATION_REQUEST, destinationSagas.addPlaceToDestination, api),
    takeLatest(DestinationTypes.ADD_PLACE_TO_DESTINATION_SUCCESS, attractionSagas.getPlacesByDestination, api),
    takeLatest(DestinationTypes.DELETE_PLACE_FROM_DESTINATION_REQUEST, destinationSagas.deletePlaceFromDestination, api),
    // the side effect upon deletion below is removed to prevent forceful reload
    // takeLatest(DestinationTypes.DELETE_PLACE_FROM_DESTINATION_SUCCESS, attractionSagas.getPlacesByDestination, api),
    takeLatest(DestinationTypes.DELETE_PLACE_FROM_DESTINATION_SUCCESS, attractionSagas.attractionClearCache, api),

    // ATTRACTION
    takeLatest(AttractionTypes.ATTRACTION_REQUEST, attractionSagas.getAttractionByDestination, api),
    takeLatest(AttractionTypes.PLACE_REQUEST, attractionSagas.getPlacesByDestination, api),
    takeLatest(AttractionTypes.GET_PLACES_V2_REQUEST, attractionSagas.getPlacesV2, api),
    takeLatest(AttractionTypes.ATTRACTION_DETAIL_REQUEST, attractionSagas.getAttractionDetail, api),
    takeLatest(AttractionTypes.PLACE_DETAIL_REQUEST, attractionSagas.getPlaceDetail, api),
    takeLatest(AttractionTypes.ATTRACTION_UPDATE_REQUEST, attractionSagas.updateAttractionDetail, api),
    takeLatest(AttractionTypes.ATTRACTION_UPDATE_SUCCESS, attractionSagas.attractionClearCache, api),
    takeLatest(AttractionTypes.ATTRACTION_SEARCH_REQUEST, attractionSagas.searchAttraction, api),
    takeLatest(AttractionTypes.PLACE_SEARCH_REQUEST, attractionSagas.searchPlace, api),
    takeLatest(AttractionTypes.ATTRACTION_CLEAR_CACHE_REQUEST, attractionSagas.attractionClearCache, api),
    takeLatest(AttractionTypes.DOWNLOAD_ATTRACTION_DATA_REQUEST, attractionSagas.downloadAttractionData, api),

    // POPULAR ATTRACTION
    takeLatest(PopularAttractionTypes.POPULAR_ATTRACTION_REQUEST, popularAttractionSagas.getPopularAttraction, api),
    takeLatest(PopularAttractionTypes.POPULAR_ATTRACTION_SAVE_REQUEST, popularAttractionSagas.savePopularAttraction, api),
    takeLatest(PopularAttractionTypes.POPULAR_ATTRACTION_DELETE_REQUEST, popularAttractionSagas.deletePopularAttraction, api),
    takeLatest(PopularAttractionTypes.POPULAR_ATTRACTION_EDIT_REQUEST, popularAttractionSagas.editPopularAttraction, api),

    // COUPON
    takeLatest(CouponTypes.COUPON_REQUEST, couponSagas.getAllCoupon, api),
    takeLatest(CouponTypes.COUPON_CREATE_REQUEST, couponSagas.createNewCoupon, api),
    takeLatest(CouponTypes.COUPON_UPDATE_REQUEST, couponSagas.updateCoupon, api),
    takeLatest(CouponTypes.BUSINESS_UPDATE_REQUEST, couponSagas.updateBusiness, api),
    takeLatest(CouponTypes.COUPON_DELETE_REQUEST, couponSagas.deleteCoupon, api),
    takeLatest(CouponTypes.BUSINESS_DELETE_REQUEST, couponSagas.deleteBusiness, api),
    takeLatest(CouponTypes.COUPON_TAG_REQUEST, couponSagas.getAllCouponTag, api),
    takeLatest(CouponTypes.COUPON_GENERATE_REQUEST, couponSagas.generateCoupon, api),
    takeLatest(CouponTypes.COUPON_SPREADSHEET_REQUEST, couponSagas.couponSpreadsheet, api),
    takeLatest(CouponTypes.COUPON_DETAIL_REQUEST, couponSagas.getCouponDetail, api),
    takeLatest(CouponTypes.HISTORY_SPREADSHEET_REQUEST, couponSagas.historySpreadsheet, api),

    takeLatest(CouponTypes.GET_COUPON_ITEM_REQUEST, couponSagas.getCouponItem, api),
    takeLatest(CouponTypes.POST_COUPON_ITEM_REQUEST, couponSagas.postCouponItem, api),
    takeLatest(CouponTypes.POST_COUPON_ITEM_TAG_REQUEST, couponSagas.postCouponItemTag, api),
    takeLatest(CouponTypes.DELETE_COUPON_ITEM_REQUEST, couponSagas.deleteCouponItem, api),
    takeLatest(CouponTypes.DELETE_COUPON_ITEM_TAG_REQUEST, couponSagas.deleteCouponItemTag, api),

    // COUPON PROVIDER
    takeLatest(CouponProviderTypes.GET_COUPON_PROVIDER_REQUEST, couponProviderSagas.getCouponProvider, api),
    takeLatest(CouponProviderTypes.POST_COUPON_PROVIDER_REQUEST, couponProviderSagas.postCouponProvider, api),
    takeLatest(CouponProviderTypes.PUT_COUPON_PROVIDER_REQUEST, couponProviderSagas.putCouponProvider, api),
    takeLatest(CouponProviderTypes.DELETE_COUPON_PROVIDER_REQUEST, couponProviderSagas.deleteCouponProvider, api),

    // COUPON PRESET
    takeLatest(CouponPresetTypes.GET_COUPON_PRESET_REQUEST, couponPresetSagas.getCouponPreset, api),
    takeLatest(CouponPresetTypes.POST_COUPON_PRESET_REQUEST, couponPresetSagas.postCouponPreset, api),
    takeLatest(CouponPresetTypes.PUT_COUPON_PRESET_REQUEST, couponPresetSagas.putCouponPreset, api),
    takeLatest(CouponPresetTypes.DELETE_COUPON_PRESET_REQUEST, couponPresetSagas.deleteCouponPreset, api),

    // COUPON AFFILIATES (PISCES)
    takeLatest(CouponTypes.GET_AFFILIATES_REQUEST, couponSagas.getAffiliates, api),
    takeLatest(CouponTypes.AFFILIATE_TRANSFER_REQUEST, couponSagas.affiliateTransfer, api),

    // PRODUCT
    takeLatest(ProductTypes.PRODUCT_REQUEST, productSagas.getProduct, api),
    takeLatest(ProductTypes.PRODUCT_CREATE_REQUEST, productSagas.createProduct, api),
    takeLatest(ProductTypes.PRODUCT_DELETE_REQUEST, productSagas.deleteProduct, api),
    takeLatest(ProductTypes.PRODUCT_UPDATE_REQUEST, productSagas.updateProduct, api),

    takeLatest(ProductTypes.GET_PRODUCT_COUNTRY_REQUEST, productSagas.getProductCountry, api),
    takeLatest(ProductTypes.POST_PRODUCT_COUNTRY_REQUEST, productSagas.postProductCountry, api),
    takeLatest(ProductTypes.DELETE_PRODUCT_COUNTRY_REQUEST, productSagas.deleteProductCountry, api),

    takeLatest(ProductTypes.GET_PRODUCT_CAMPAIGN_REQUEST, productSagas.getProductCampaign, api),
    takeLatest(ProductTypes.POST_PRODUCT_CAMPAIGN_REQUEST, productSagas.postProductCampaign, api),
    takeLatest(ProductTypes.PUT_PRODUCT_CAMPAIGN_REQUEST, productSagas.putProductCampaign, api),
    takeLatest(ProductTypes.DELETE_PRODUCT_CAMPAIGN_REQUEST, productSagas.deleteProductCampaign, api),

    takeLatest(ProductTypes.GET_PRODUCT_VARIANT_REQUEST, productSagas.getProductVariant, api),
    takeLatest(ProductTypes.POST_PRODUCT_VARIANT_REQUEST, productSagas.postProductVariant, api),
    takeLatest(ProductTypes.POST_PRODUCT_VARIANT_SUCCESS, productSagas.getProductVariant, api),
    takeLatest(ProductTypes.PUT_PRODUCT_VARIANT_REQUEST, productSagas.putProductVariant, api),
    takeLatest(ProductTypes.PUT_PRODUCT_VARIANT_SUCCESS, productSagas.getProductVariant, api),
    takeLatest(ProductTypes.DELETE_PRODUCT_VARIANT_REQUEST, productSagas.deleteProductVariant, api),
    takeLatest(ProductTypes.DELETE_PRODUCT_VARIANT_SUCCESS, productSagas.getProductVariant, api),

    takeLatest(ProductTypes.GET_PRODUCT_VARIANT_ITEM_REQUEST, productSagas.getProductVariantItem, api),
    takeLatest(ProductTypes.POST_PRODUCT_VARIANT_ITEM_REQUEST, productSagas.postProductVariantItem, api),
    takeLatest(ProductTypes.POST_PRODUCT_VARIANT_ITEM_SUCCESS, productSagas.getProductVariantItem, api),
    takeLatest(ProductTypes.DELETE_PRODUCT_VARIANT_ITEM_REQUEST, productSagas.deleteProductVariantItem, api),
    takeLatest(ProductTypes.DELETE_PRODUCT_VARIANT_ITEM_SUCCESS, productSagas.getProductVariantItem, api),

    // E-SIM
    takeLatest(EsimsTypes.GET_ALL_ESIMS_REQUEST, esimsSagas.getAllEsims, api),
    takeLatest(EsimsTypes.ESIM_UPDATE_REQUEST, esimsSagas.updateEsimData, api),
    takeLatest(EsimsTypes.ESIM_UPDATE_COUNTRY_REQUEST, esimsSagas.updateEsimCountry, api),
    takeLatest(EsimsTypes.ESIM_UPDATE_VARIANT_REQUEST, esimsSagas.updateEsimVarian, api),

    // EVENTS
    takeLatest(EventsTypes.GET_ALL_EVENTS_REQUEST, eventsSagas.getAllEvents, api),
    takeLatest(EventsTypes.GET_EVENTS_CATEGORIES_REQUEST, eventsSagas.getEventsCategories, api),
    takeLatest(EventsTypes.GET_ALL_POPULAR_EVENTS_REQUEST, eventsSagas.getAllPopularEvents, api),
    takeLatest(EventsTypes.SET_POPULAR_EVENT_REQUEST, eventsSagas.setPopularEvent, api),
    takeLatest(EventsTypes.RESET_EVENT_DESCRIPTION_REQUEST, eventsSagas.resetEventDescription, api),
    takeLatest(EventsTypes.RESET_EVENT_DESCRIPTION_SUCCESS, eventsSagas.getAllEvents, api),
    takeLatest(EventsTypes.UPDATE_EVENT_DESCRIPTION_REQUEST, eventsSagas.updateEventDescription, api),
    takeLatest(EventsTypes.UPDATE_EVENT_DESCRIPTION_SUCCESS, eventsSagas.getAllEvents, api),

    // INSURANCE: TRAVEL PACKAGE
    takeLatest(InsuranceTypes.GET_TRAVEL_PACKAGE_REQUEST, insuranceSagas.getTravelPackage, api),
    takeLatest(InsuranceTypes.POST_TRAVEL_PACKAGE_REQUEST, insuranceSagas.postTravelPackage, api),
    takeLatest(InsuranceTypes.PUT_TRAVEL_PACKAGE_REQUEST, insuranceSagas.putTravelPackage, api),
    takeLatest(InsuranceTypes.DELETE_TRAVEL_PACKAGE_REQUEST, insuranceSagas.deleteTravelPackage, api),

    // INSURANCE: TRAVEL PACKAGE PRICE
    takeLatest(InsuranceTypes.VIEW_TRAVEL_PACKAGE_REQUEST, insuranceSagas.viewTravelPackage, api),
    takeLatest(InsuranceTypes.POST_TRAVEL_PACKAGE_PRICE_REQUEST, insuranceSagas.postTravelPackagePrice, api),
    takeLatest(InsuranceTypes.PUT_TRAVEL_PACKAGE_PRICE_REQUEST, insuranceSagas.putTravelPackagePrice, api),
    takeLatest(InsuranceTypes.SWITCH_TRAVEL_PACKAGE_PRICE_REQUEST, insuranceSagas.switchTravelPackagePrice, api),

    // INSURANCE: TICKET
    takeLatest(InsuranceTypes.GET_TICKET_PACKAGE_REQUEST, insuranceSagas.getTicketPackage, api),
    takeLatest(InsuranceTypes.POST_TICKET_PACKAGE_REQUEST, insuranceSagas.postTicketPackage, api),
    takeLatest(InsuranceTypes.PUT_TICKET_PACKAGE_REQUEST, insuranceSagas.putTicketPackage, api),
    takeLatest(InsuranceTypes.DELETE_TICKET_PACKAGE_REQUEST, insuranceSagas.deleteTicketPackage, api),

    // BANNER
    takeLatest(BannerTypes.BANNER_REQUEST, bannerSagas.getBanners, api),
    takeLatest(BannerTypes.BANNER_CREATE_REQUEST, bannerSagas.createBanner, api),
    takeLatest(BannerTypes.BANNER_DELETE_REQUEST, bannerSagas.deleteBanner, api),
    takeLatest(BannerTypes.BANNER_UPDATE_REQUEST, bannerSagas.updateBanner, api),

    // MARKUP
    takeLatest(MarkupTypes.MARKUP_REQUEST, markupSagas.getMarkup, api),
    takeLatest(MarkupTypes.MARKUP_CREATE_REQUEST, markupSagas.createMarkup, api),
    takeLatest(MarkupTypes.MARKUP_CREATE_SUCCESS, markupSagas.getMarkup, api),
    takeLatest(MarkupTypes.MARKUP_UPDATE_REQUEST, markupSagas.updateMarkup, api),
    takeLatest(MarkupTypes.MARKUP_UPDATE_SUCCESS, markupSagas.getMarkup, api),
    takeLatest(MarkupTypes.MARKUP_DELETE_REQUEST, markupSagas.deleteMarkup, api),
    takeLatest(MarkupTypes.MARKUP_DELETE_SUCCESS, markupSagas.getMarkup, api),
    takeLatest(MarkupTypes.MARKUP_ITEM_GET_REQUEST, markupSagas.markupItemGet, api),
    takeLatest(MarkupTypes.MARKUP_ITEM_CREATE_REQUEST, markupSagas.markupItemCreate, api),
    takeLatest(MarkupTypes.MARKUP_ITEM_UPDATE_REQUEST, markupSagas.markupItemUpdate, api),
    takeLatest(MarkupTypes.MARKUP_ITEM_DELETE_REQUEST, markupSagas.markupItemDelete, api),

    // EXCHANGE RATE
    takeLatest(ExchangeRateTypes.EXCHANGE_RATE_REQUEST, exchangeRateSagas.getExchangeRate, api),
    takeLatest(ExchangeRateTypes.EXCHANGE_RATE_SINGLE_REQUEST, exchangeRateSagas.getSingleExchangeRate, api),
    takeLatest(ExchangeRateTypes.EXCHANGE_RATE_UPDATE_REQUEST, exchangeRateSagas.updateExchangeRate, api),
    takeLatest(ExchangeRateTypes.EXCHANGE_RATE_UPDATE_SUCCESS, exchangeRateSagas.getExchangeRate, api),

    // USER
    takeLatest(UserTypes.USER_REQUEST, userSagas.getUser, api),
    takeLatest(UserTypes.USER_COUNT_REQUEST, userSagas.getUserCount, api),
    takeLatest(UserTypes.USER_CREATE_REQUEST, userSagas.createUser, api),
    takeLatest(UserTypes.USER_CREATE_SUCCESS, userSagas.getUser, api),
    takeLatest(UserTypes.USER_UPDATE_REQUEST, userSagas.updateUser, api),
    takeLatest(UserTypes.USER_UPDATE_SUCCESS, userSagas.getUser, api),
    takeLatest(UserTypes.USER_DELETE_REQUEST, userSagas.deleteUser, api),
    takeLatest(UserTypes.USER_DELETE_SUCCESS, userSagas.getUser, api),
    takeLatest(UserTypes.USER_LIST_REQUEST, userSagas.downloadUserList, api),

    // ORDER
    takeLatest(OrderTypes.ORDER_REQUEST, orderSagas.getOrder, api),
    takeLatest(OrderTypes.ORDER_SINGLE_REQUEST, orderSagas.getOrderSingle, api),
    takeLatest(OrderTypes.ORDER_DETAIL_LIST_REQUEST, orderSagas.getOrderDetailList, api),
    takeLatest(OrderTypes.ORDER_CONFIRM_REQUEST, orderSagas.confirmOrder, api),
    takeLatest(OrderTypes.ORDER_CONFIRM_SUCCESS, orderSagas.getOrder, api),
    takeLatest(OrderTypes.ORDER_UPDATE_REQUEST, orderSagas.updateOrder, api),
    takeLatest(OrderTypes.ORDER_CHECKOUT_REQUEST, orderSagas.updateCheckoutOrder, api),
    takeLatest(OrderTypes.ORDER_UPDATE_SUCCESS, orderSagas.getOrder, api),
    takeLatest(OrderTypes.ORDER_UPDATE_AMOUNT_REQUEST, orderSagas.updateOrderAmount, api),
    takeLatest(OrderTypes.ORDER_UPDATE_AMOUNT_SUCCESS, orderSagas.getOrder, api),
    takeLatest(OrderTypes.ORDER_LIST_DOWNLOAD_REQUEST, orderSagas.orderListSpreadsheet, api),
    takeLatest(OrderTypes.ORDER_DETAIL_LIST_DOWNLOAD_REQUEST, orderSagas.orderDetailListSpreadsheet, api),
    takeLatest(OrderTypes.ORDER_INVOICE_REQUEST, orderSagas.downloadOrderInvoice, api),
    takeLatest(OrderTypes.RESEND_ORDER_VOUCHER_REQUEST, orderSagas.resendOrderVoucher, api),
    takeLatest(OrderTypes.GET_ORDER_REPORT_REQUEST, orderSagas.getOrderReport, api),
    takeLatest(OrderTypes.GET_ORDER_REPORT_SPREADSHEET_REQUEST, orderSagas.getOrderReportSpreadsheet, api),
    takeLatest(OrderTypes.REFUND_DANA_REQUEST, orderSagas.refundDana, api),

    // ORDER (CHATBOT)
    takeLatest(OrderTypes.GET_CHATBOT_ORDER_REQUEST, orderSagas.getChatbotOrder, api),
    takeLatest(OrderTypes.POST_CHATBOT_ORDER_REQUEST, orderSagas.postChatbotOrder, api),

    // TRANSFER HISTORY
    takeLatest(TransferHistoryTypes.TRANSFER_HISTORY_REQUEST, transferHistorySagas.getTransferHistory, api),
    takeLatest(TransferHistoryTypes.TRANSFER_HISTORY_MATCHES_REQUEST, transferHistorySagas.getTransferHistoryMatches, api),
    takeLatest(TransferHistoryTypes.TRANSFER_HISTORY_UPDATE_REQUEST, transferHistorySagas.updateTransferHistory, api),
    takeLatest(TransferHistoryTypes.TRANSFER_HISTORY_UPDATE_SUCCESS, transferHistorySagas.getTransferHistory, api),
    takeLatest(TransferHistoryTypes.TRANSFER_HISTORY_LIST_DOWNLOAD_REQUEST, transferHistorySagas.transferHistoryListSpreadsheet, api),

    // FILES
    takeLatest(FilesTypes.FILES_UPLOAD_REQUEST, uploadFiles, api),
    takeLatest(FilesTypes.FILES_UPLOAD_SUCCESS, attractionSagas.attractionClearCache, api),

    // REVIEW
    takeLatest(ReviewTypes.REVIEW_LIST_REQUEST, reviewSagas.getReviews, api),
    takeLatest(ReviewTypes.REVIEW_APPROVE_REQUEST, reviewSagas.approveReview, api),
    takeLatest(ReviewTypes.REVIEW_APPROVE_SUCCESS, reviewSagas.getReviews, api),

    // DATABASE
    takeLatest(DbTypes.DB_DUMP_REQUEST, dbSagas.dbDump, api),

    // ECOMMERCE-MANAGE-CATEGORY
    takeLatest(CategoryTypes.GET_CATEGORY_REQUEST, categorySagas.getCategory, api),
    takeLatest(CategoryTypes.GET_SINGLE_CATEGORY_REQUEST, categorySagas.getSingleCategory, api),
    takeLatest(CategoryTypes.CREATE_CATEGORY_REQUEST, categorySagas.createCategory, api),
    takeLatest(CategoryTypes.UPDATE_CATEGORY_REQUEST, categorySagas.updateCategory, api),

    // ECOMMERCE-MANAGE-VARIANT-SIZE
    takeLatest(SizeTypes.GET_SIZE_REQUEST, sizeSagas.getSize, api),
    takeLatest(SizeTypes.GET_ALL_SIZE_REQUEST, sizeSagas.getAllSize, api),
    takeLatest(SizeTypes.CREATE_SIZE_REQUEST, sizeSagas.createSize, api),
    takeLatest(SizeTypes.UPDATE_SIZE_REQUEST, sizeSagas.updateSize, api),
    takeLatest(SizeTypes.DELETE_SIZE_REQUEST, sizeSagas.deleteSize, api),

    // ECOMMERCE-MANAGE-VARIANT-COLOUR
    takeLatest(ColourTypes.GET_COLOUR_REQUEST, colourSagas.getColour, api),
    takeLatest(ColourTypes.GET_ALL_COLOUR_REQUEST, colourSagas.getAllColour, api),
    takeLatest(ColourTypes.CREATE_COLOUR_REQUEST, colourSagas.createColour, api),
    takeLatest(ColourTypes.UPDATE_COLOUR_REQUEST, colourSagas.updateColour, api),
    takeLatest(ColourTypes.DELETE_COLOUR_REQUEST, colourSagas.deleteColour, api),

    // ECOMMERCE-MANAGE-BRAND
    takeLatest(BrandTypes.GET_BRAND_REQUEST, brandSagas.getBrand, api),
    takeLatest(BrandTypes.CREATE_BRAND_REQUEST, brandSagas.createBrand, api),
    takeLatest(BrandTypes.UPDATE_BRAND_REQUEST, brandSagas.updateBrand, api),
    takeLatest(BrandTypes.DELETE_BRAND_REQUEST, brandSagas.deleteBrand, api),
    takeLatest(BrandTypes.GET_SINGLE_BRAND_REQUEST, brandSagas.getSingleBrand, api),
    takeLatest(BrandTypes.CREATE_CATEGORY_BRAND_REQUEST, brandSagas.createCategoryBrand, api),
    takeLatest(BrandTypes.UPDATE_CATEGORY_BRAND_REQUEST, brandSagas.updateCategoryBrand, api),
    takeLatest(BrandTypes.DELETE_CATEGORY_BRAND_REQUEST, brandSagas.deleteCategoryBrand, api),

    // ECOMMERCE-MANAGE-WAREHOUSE
    takeLatest(WarehouseTypes.GET_WAREHOUSE_REQUEST, warehouseSagas.getWarehouse, api),
    takeLatest(WarehouseTypes.CREATE_WAREHOUSE_REQUEST, warehouseSagas.createWarehouse, api),
    takeLatest(WarehouseTypes.UPDATE_WAREHOUSE_REQUEST, warehouseSagas.updateWarehouse, api),
    takeLatest(WarehouseTypes.DELETE_WAREHOUSE_REQUEST, warehouseSagas.deleteWarehouse, api),

    // ECOMMERCE-MANAGE-SUPPLIER
    takeLatest(SupplierTypes.GET_SUPPLIER_REQUEST, supplierSagas.getSupplier, api),
    takeLatest(SupplierTypes.CREATE_SUPPLIER_REQUEST, supplierSagas.createSupplier, api),
    takeLatest(SupplierTypes.UPDATE_SUPPLIER_REQUEST, supplierSagas.updateSupplier, api),
    takeLatest(SupplierTypes.DELETE_SUPPLIER_REQUEST, supplierSagas.deleteSupplier, api),

    // Ecommerce manage location
    takeLatest(LocationTypes.GET_PROVINCE_REQUEST, LocationSagas.getProvince, api),
    takeLatest(LocationTypes.GET_CITY_REQUEST, LocationSagas.getCities, api),
    takeLatest(LocationTypes.GET_DISTRICT_REQUEST, LocationSagas.getDistricts, api),

    // ECOMMERCE-MANAGE-INVENTORY
    takeLatest(InventoryTypes.GET_INVENTORY_REQUEST, inventorySagas.getInventory, api),
    takeLatest(InventoryTypes.CREATE_INVENTORY_REQUEST, inventorySagas.createInventory, api),
    takeLatest(InventoryTypes.UPDATE_INVENTORY_REQUEST, inventorySagas.updateInventory, api),
    takeLatest(InventoryTypes.UPDATE_INVENTORY_IMAGE_REQUEST, inventorySagas.updateInventoryImage, api),
    takeLatest(InventoryTypes.DELETE_INVENTORY_REQUEST, inventorySagas.deleteInventory, api),

    // ECOMMERCE-MANAGE-ECOMMERCE-PRODUCT
    takeLatest(EcommerceProductTypes.GET_ECOMMERCE_PRODUCT_REQUEST, ecommerceProductSagas.getEcommerceProduct, api),
    takeLatest(EcommerceProductTypes.VIEW_ECOMMERCE_PRODUCT_REQUEST, ecommerceProductSagas.viewEcommerceProduct, api),
    takeLatest(EcommerceProductTypes.CREATE_ECOMMERCE_PRODUCT_REQUEST, ecommerceProductSagas.createEcommerceProduct, api),
    takeLatest(EcommerceProductTypes.CREATE_ECOMMERCE_PRODUCT_STOCK_REQUEST, ecommerceProductSagas.createEcommerceProductStock, api),
    takeLatest(EcommerceProductTypes.UPDATE_ECOMMERCE_PRODUCT_REQUEST, ecommerceProductSagas.updateEcommerceProduct, api),
    takeLatest(EcommerceProductTypes.DELETE_ECOMMERCE_PRODUCT_REQUEST, ecommerceProductSagas.deleteEcommerceProduct, api),

    // ECOMMERCE-MANAGE-ECOMMERCE-ORDER
    takeLatest(EcommerceOrderTypes.GET_ECOMMERCE_ORDER_REQUEST, ecommerceOrderSagas.getEcommerceOrder, api),
    takeLatest(EcommerceOrderTypes.GET_ECOMMERCE_ORDER_SHIPPING_REQUEST, ecommerceOrderSagas.getEcommerceOrderShipping, api),
    takeLatest(EcommerceOrderTypes.POST_ECOMMERCE_ORDER_SHIPPING_REQUEST, ecommerceOrderSagas.postEcommerceOrderShipping, api),
    takeLatest(EcommerceOrderTypes.PUT_ECOMMERCE_ORDER_SHIPPING_REQUEST, ecommerceOrderSagas.putEcommerceOrderShipping, api),
    takeLatest(EcommerceOrderTypes.DELETE_ECOMMERCE_ORDER_SHIPPING_REQUEST, ecommerceOrderSagas.deleteEcommerceOrderShipping, api),

    // SECTIONS
    takeLatest(SectionTypes.GET_SECTION_REQUEST, sectionSagas.getSection, api),
    takeLatest(SectionTypes.POST_SECTION_REQUEST, sectionSagas.postSection, api),
    takeLatest(SectionTypes.PUT_SECTION_REQUEST, sectionSagas.putSection, api),
    takeLatest(SectionTypes.DELETE_SECTION_REQUEST, sectionSagas.deleteSection, api),
    takeLatest(SectionTypes.POST_SUB_SECTION_REQUEST, sectionSagas.postSubSection, api),
    takeLatest(SectionTypes.PUT_SUB_SECTION_REQUEST, sectionSagas.putSubSection, api),
    takeLatest(SectionTypes.DELETE_SUB_SECTION_REQUEST, sectionSagas.deleteSubSection, api),

    // ATTRACTION PROMO
    takeLatest(AttractionPromoTypes.ATTRACTION_PROMO_REQUEST, attractionPromoSagas.getAttractionPromo, api),
    takeLatest(AttractionPromoTypes.POST_ATTRACTION_PROMO_REQUEST, attractionPromoSagas.postAttractionPromo, api),
    takeLatest(AttractionPromoTypes.POST_ATTRACTION_PROMO_SUCCESS, attractionPromoSagas.getAttractionPromo, api),
    takeLatest(AttractionPromoTypes.PUT_ATTRACTION_PROMO_REQUEST, attractionPromoSagas.putAttractionPromo, api),
    takeLatest(AttractionPromoTypes.PUT_ATTRACTION_PROMO_SUCCESS, attractionPromoSagas.getAttractionPromo, api),
    takeLatest(AttractionPromoTypes.DELETE_ATTRACTION_PROMO_REQUEST, attractionPromoSagas.deleteAttractionPromo, api),
    takeLatest(AttractionPromoTypes.DELETE_ATTRACTION_PROMO_SUCCESS, attractionPromoSagas.getAttractionPromo, api),

    // FAILED TRANSACTION
    takeLatest(FailedTransactionTypes.GET_FAILED_TRANSACTION_REQUEST, failedTransactionSagas.getFailedTransaction, api),
    takeLatest(FailedTransactionTypes.TRIGGER_FAILED_TRANSACTION_REQUEST, failedTransactionSagas.triggerFailedTransaction, api),

    // CUSTOM SAGAS FOR SELECTORS
    takeLatest(ProductTypes.GET_PRODUCT_CUSTOM_REQUEST, productSagas.getProductCustom, api),
    takeLatest(BannerTypes.BANNER_CUSTOM_REQUEST, bannerSagas.getBannerCustom, api),
    takeLatest(InventoryTypes.GET_INVENTORY_CUSTOM_REQUEST, inventorySagas.getInventoryCustom, api),

    // SCHEDULER
    takeLatest(SchedulerTypes.GET_SCHEDULER_REQUEST, schedulerSagas.getScheduler, api),
    takeLatest(SchedulerTypes.GET_SCHEDULER_DETAIL_REQUEST, schedulerSagas.getSchedulerDetail, api),
    takeLatest(SchedulerTypes.POST_SCHEDULER_REQUEST, schedulerSagas.postScheduler, api),
    takeLatest(SchedulerTypes.PUT_SCHEDULER_REQUEST, schedulerSagas.putScheduler, api),
    takeLatest(SchedulerTypes.PUT_SCHEDULER_SUCCESS, schedulerSagas.getSchedulerDetail, api),
    takeLatest(SchedulerTypes.DELETE_SCHEDULER_REQUEST, schedulerSagas.deleteScheduler, api),

    // cronReport
    takeLatest(CronReportTypes.GET_CRON_REPORT_REQUEST, cronReportSagas.getCronReport, api),
    takeLatest(CronReportTypes.GET_CRON_REPORT_ITEM_REQUEST, cronReportSagas.getCronReportItem, api),
    takeLatest(CronReportTypes.DISABLE_ATTRACTION_REQUEST, cronReportSagas.disableAttraction, api),
    takeLatest(CronReportTypes.ENABLE_ATTRACTION_REQUEST, cronReportSagas.enableAttraction, api),
    takeLatest(CronReportTypes.GET_WHITELIST_REQUEST, cronReportSagas.getWhitelist, api),
    takeLatest(CronReportTypes.PUT_WHITELIST_REQUEST, cronReportSagas.putWhitelist, api),
    takeLatest(CronReportTypes.DELETE_WHITELIST_REQUEST, cronReportSagas.deleteWhitelist, api),

    // Promo Section
    takeLatest(PromoSectionTypes.GET_PROMO_SECTION_REQUEST, promoSectionSagas.getPromoSection, api),
    takeLatest(PromoSectionTypes.UPDATE_PROMO_SECTION_REQUEST, promoSectionSagas.updatePromoSection, api)
  ])
}



// WEBPACK FOOTER //
// ./src/Sagas/index.js